(() => {
  if (window.__bicailVariantAvailabilityFix) return;
  window.__bicailVariantAvailabilityFix = true;
  if (!/^\/products\//.test(location.pathname)) return;

  let variantsPromise;
  const getVariants = () => variantsPromise ||= fetch(location.pathname + '.js', { credentials: 'same-origin' })
    .then(response => { if (!response.ok) throw new Error('Product availability request failed'); return response.json(); })
    .then(product => new Map(product.variants.map(variant => [String(variant.id), Boolean(variant.available)])))
    .catch(() => new Map());

  const sync = async () => {
    const availability = await getVariants();
    if (!availability.size) return;
    document.querySelectorAll('main form[action*="/cart/add"]').forEach(form => {
      const id = form.querySelector('input[name="id"]')?.value;
      if (!id || !availability.has(String(id))) return;
      const available = availability.get(String(id));
      form.querySelectorAll('button[name="add"], .main-product-atc').forEach(button => {
        button.disabled = !available;
        if (available) {
          button.removeAttribute('disabled');
          button.removeAttribute('data-unavailable');
        } else {
          button.setAttribute('disabled', 'disabled');
          button.dataset.unavailable = 'true';
        }
      });
    });
  };

  const schedule = () => [0, 250, 750, 1500].forEach(delay => setTimeout(sync, delay));
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects, variant-radios, form[action*="/cart/add"]')) schedule();
  });
  document.addEventListener('variantChange', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });

  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' && record.attributeName === 'disabled' && record.target.matches('.main-product-atc, button[name="add"]'))) sync();
  });
  observer.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
  schedule();
})();
